module.exports = __webpack_public_path__ + "b554c3a15bfcc96c9743823ce3c6f81f.pdf";